// assets/tc-shape-config.js
(function () {
  // Map of all shapes → overlay/product/accessory settings
  // Offsets/scales are all neutral so your current look stays identical.
  window.TCShapeConfig = {
    'Small Round Necklace': {
      product: 'custom-round-map-pendant-small',
      overlayDesktop: '//cdn.shopify.com/s/files/1/1574/5909/t/2/assets/roundnecklacesmall.png',
      overlayMobile:  '//cdn.shopify.com/s/files/1/1574/5909/t/2/assets/roundnecklacesmallmobile5.png',
      desktopScale: 1, desktopOffsetX: 0, desktopOffsetY: 0,
      mobileScale:  1.08, mobileOffsetX: 0, mobileOffsetY: 0,
      accessory: 'https://cdn.shopify.com/s/files/1/1574/5909/files/round_bail_w_chain_shopify.stl',
      accessoryOx: 1.9, accessoryOy: 0
    },

    'Medium Round Necklace': {
      product: 'custom-round-map-pendant-medium',
      overlayDesktop: '//cdn.shopify.com/s/files/1/1574/5909/t/2/assets/roundnecklace_wm.png',
      overlayMobile:  '//cdn.shopify.com/s/files/1/1574/5909/files/roundnecklace_mobile_medium_e3fbb4f8-8171-40af-b4c8-a6367792322c.png?v=1766516370',
      desktopScale: 1, desktopOffsetX: 0, desktopOffsetY: 0,
      mobileScale:  1, mobileOffsetX: 0, mobileOffsetY: 0,
      accessory: 'https://cdn.shopify.com/s/files/1/1574/5909/files/large_bail_w_chain.stl?v=1759833103',
      accessoryOx: 1.5, accessoryOy: 0.5,
      zoomBiasDesktop: 0.95,
      zoomBiasMobile:  0.95
    },

    'Large Round Necklace': {
      product: 'custom-round-map-pendant-large',
      overlayDesktop: 'https://cdn.shopify.com/s/files/1/1574/5909/files/large_round_mask.png?v=1759846415',
      overlayMobile:  'https://cdn.shopify.com/s/files/1/1574/5909/files/roundnecklace_mobile_large_f.png?v=1760089412',
      desktopScale: 1, desktopOffsetX: 0, desktopOffsetY: 0,
      mobileScale:  1, mobileOffsetX: 0, mobileOffsetY: 0,
      accessory: 'https://cdn.shopify.com/s/files/1/1574/5909/files/large_bail_w_chain.stl?v=1759833103',
      accessoryOx: 1.5, accessoryOy: 0.3,
      zoomBiasDesktop: 0.85,
      zoomBiasMobile:  0.85
    },

    'Earrings': {
      product: 'custom-round-map-earring',
      overlayDesktop: '//cdn.shopify.com/s/files/1/1574/5909/t/14/assets/roundearrings.png',
      overlayMobile:  'https://cdn.shopify.com/s/files/1/1574/5909/files/roundearrings_mobile.png?v=1760093099',
      desktopScale: 1, desktopOffsetX: 0, desktopOffsetY: 0,
      mobileScale:  1, mobileOffsetX: 0, mobileOffsetY: 0,
      accessory: 'https://cdn.shopify.com/s/files/1/1574/5909/files/earring_base_upright.stl?v=1759904448',
      accessoryOx: 0, accessoryOy: -18.5
    },

    'Cufflinks': {
      product: 'custom-round-map-cufflink',
      overlayDesktop: '//cdn.shopify.com/s/files/1/1574/5909/t/12/assets/cufflink5.png',
      overlayMobile:  'https://cdn.shopify.com/s/files/1/1574/5909/files/cufflink_mobile3.png?v=1760092649',
      desktopScale: 1, desktopOffsetX: 0, desktopOffsetY: 0,
      mobileScale:  1, mobileOffsetX: 0, mobileOffsetY: 0,
      accessory: 'https://cdn.shopify.com/s/files/1/1574/5909/files/cufflink_base_upright.stl?v=1759904446',
      accessoryOx: 0, accessoryOy: -20,
      accessoryOz: -8.12   // negative = move toward −Z (back)
    },

    'Tie Bar': {
      product: 'custom-map-tiebar',
      overlayDesktop: 'https://cdn.shopify.com/s/files/1/1574/5909/files/custom_map_tie_bar2.png?v=1760180862',
      overlayMobile:  'https://cdn.shopify.com/s/files/1/1574/5909/files/tie_bar_mobile_b.png?v=1760181738',
      desktopScale: 1, desktopOffsetX: 0, desktopOffsetY: 0,
      mobileScale:  1, mobileOffsetX: 0, mobileOffsetY: 0,
      accessory: 'https://cdn.shopify.com/s/files/1/1574/5909/files/tie_bar_base_ry180_upright.stl?v=1759905949',
      accessoryOx: 2, accessoryOy: -15,
      zoomBiasDesktop: 0.5,
      zoomBiasMobile:  0.5,
      accessoryOz: -3.92   // negative = move toward −Z (back)
    }
  };
})();
